<template>
  <el-menu
    :default-active="$route.fullPath"
    :collapse="adminCollapse"
    :router="true"
    :unique-opened="true"
    :collapse-transition="false"
  >
    <template v-for="menu in adminMenus">
      <el-submenu :index="menu.id + ''" :key="menu.id">
        <template slot="title">
          <i :class="menu.menuIcon"></i><span>{{ menu.menuName }}</span>
        </template>
        <template v-for="children in menu.children">
          <el-menu-item :index="children.menuPath" :key="children.id">
            <template slot="title">
              <i :class="children.menuIcon"></i>
              <span>{{ children.menuName }}</span>
            </template>
          </el-menu-item>
        </template>
      </el-submenu>
    </template>
  </el-menu>
</template>

<script>
export default {
  data() {
    return {
      adminCollapse: false,
    };
  },
  computed: {
    adminMenus() {
      return this.$store.state.adminMenus;
    },
  },
  watch: {
    "$store.state.adminCollapse": {
      handler: function (value) {
        this.adminCollapse = value;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./menu.scss");
</style>